module.exports = __webpack_public_path__ + "static/media/MAMA-SOUL.eefcc1c6.png";